export default __webpack_public_path__ + "static/media/podd_map.png.webp";